'use client'
import {Link} from "@/i18n/routing";
import MobileMenuWrapper from '@/components/layout/headers/MobileMenuWrapper';
import {useTranslations} from 'next-intl';
import {useState} from 'react';
import {ProductSidebarTags} from '@/libs/constants/common.constants';

export default function CategoriesMenu({
    home,
    socialLinks,
    categories = [],
    brands = [],
    isCatalog = false,
    onCategorySelect = (..._) => {},
    onSubcategorySelect = (..._) => {},
    onBrandSelect = (..._) => {},
    categoryInput,
    subcategoryInput,
    brandInput,
    onTagSelect,
    tagInput
}) {
  const t = useTranslations('header');
  const tags = useTranslations('catalog.productSectionTags');
  const [openedIdx, setOpenedIdx] = useState();
  
  const onSubcategory = (e, alt1, title1, isActive, idx) => {
    if (subcategoryInput === alt1) {
      setOpenedIdx(idx);
    }
    onSubcategorySelect(e, alt1, title1, isActive);
  }
  
  return (
      <MobileMenuWrapper id="categories" home={home} socialLinks={socialLinks}>
        <div className="ltn__utilize-menu categories-menu">
          <ul className="tags-menu">
            {ProductSidebarTags.map((title, idx) => (
                <li key={idx} className="mt-0">
                  <div className={`menu-title ${title === tagInput ? 'selected' : ''}`}>
                    <Link
                        href={`/catalog?&tag=${title.toLowerCase()}`}
                        className={isCatalog ? 'ltn__utilize-close' : ''}
                        onClick={(e) => onTagSelect(e, title, title === tagInput)}
                    >{tags(title)}</Link>
                  </div>
                </li>
            ))}
          </ul>
          <hr/>
          <div className="mt-3 mb-2 cat-title">
            {t('categories')}
          </div>
          <ul>
            {categories.map(({title, alt, icon, subcategories}, idx) => {
              const hasActiveSubcategory = subcategories.some(sub => sub.alt === subcategoryInput);
              return (
                  <li key={idx} className={openedIdx === idx || hasActiveSubcategory ? 'active' : ''}>
                    <div className={`menu-title ${alt === categoryInput ? 'selected' : ''}`}>
                      <i className={icon}></i>
                      <Link
                          href={`/catalog?category=${alt}&title=${title}`}
                          className={isCatalog ? 'ltn__utilize-close' : ''}
                          onClick={(e) => onCategorySelect(e, alt, title, alt === categoryInput)}
                      >{title}</Link>
                    </div>
                    {Array.isArray(subcategories) && subcategories.length > 0 ? (
                        <ul className="sub-menu" style={openedIdx === idx || hasActiveSubcategory ? {display: 'block'} : {}}>
                          {subcategories.map(({title: title1, alt: alt1}, idx1) => (
                              <li key={idx1} className={alt1 === subcategoryInput ? 'selected' : ''}>
                                <Link
                                    href={`/catalog?subcategory=${alt1}&title=${title1}`}
                                    className={isCatalog ? 'ltn__utilize-close' : ''}
                                    onClick={(e) => onSubcategory(e, alt1, title1, alt1 === subcategoryInput, idx)}
                                >
                                  {title1}
                                </Link>
                              </li>
                          ))
                          }
                        </ul>
                    ) : ('')}
                  </li>
              )
            })}
          </ul>
          {
            brands?.length ? (
                <>
                  <hr/>
                  <div className="mt-3 mb-2 cat-title">
                    {t('brands')}
                  </div>
                  <ul>
                    {brands.map(({title, alt}, idx) => (
                        <li key={idx} className="mt-0">
                          <div className={`menu-title ${alt === brandInput ? 'selected' : ''}`}>
                            <Link
                                href={`/catalog?brand=${alt}&title=${title}`}
                                className={isCatalog ? 'ltn__utilize-close' : ''}
                                onClick={(e) => onBrandSelect(e, alt, title, alt === brandInput)}
                            >{title}</Link>
                          </div>
                        </li>
                    ))}
                  </ul>
                </>
            ) : ''
          }
        </div>
      </MobileMenuWrapper>
  );
};
